import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';

import { HttpClientModule } from '@angular/common/http';

import { UrlHandlingStrategy } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login.service';
import { Ng1NgxUrlHandlingStrategyService } from '../routing/services/ng1-ngx-url-handling-strategy.service';

function getRootScope($injector : any) {
    return $injector.get('$rootScope');
}

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        UpgradeModule
    ],
    declarations: [
        LoginComponent,
    ],
    providers: [
        {
            provide: '$rootScope',
            useFactory: getRootScope,
            deps: [ '$injector' ]
        },
        { provide: UrlHandlingStrategy, useClass: Ng1NgxUrlHandlingStrategyService },
        LoginService
    ],
    bootstrap: [
        LoginComponent,
    ],
    entryComponents: [
    ]
})
export class LoginModule {

}
